import i18next from "i18next";

export enum LanguageTypeEnum {
  ENGLISH = "en",
  SPANISH = "es"
}

export const LanguageTypeLabel = (key: string): string => ({
  [LanguageTypeEnum.ENGLISH]: i18next.t("ENGLISH"),
  [LanguageTypeEnum.SPANISH]: i18next.t("SPANISH")
})[key] ?? key;

export const getLanguageTypes = () =>
  Object.values(LanguageTypeEnum).map((key) => ({
    key,
    value: key,
    label: LanguageTypeLabel(key)
  }));